import { client } from '@atlassian/rovo-content-bridge-api';

export const ROVO_EXTENSION_CLIENT_ID = client('rovo-extension');
